module.exports = __webpack_public_path__ + "img/content-bg.b78f267e.png";